import { Color } from '@billy/design-system'
import { Table } from '@shinetools/lumen-react'
import { ReactElement } from 'react'

import { formatAmount } from '../../../../../../constants/LedgerEntriesTableCells'
import { TruncatedTextCell } from '../../../../../../elements/TruncatedTextCell'
import type { LedgerEntryColumnDef } from '../../../../../../hooks/useLedgerEntriesTableColumns'

interface TotalBalanceRowProps {
  columns: LedgerEntryColumnDef[]
  isBold?: boolean
  isSticky?: boolean
  totalBalance: number
}

export const TotalBalanceRow = ({
  columns,
  isBold = true,
  isSticky = false,
  totalBalance,
}: TotalBalanceRowProps): ReactElement => (
  <Table.Row data-totals-row={isSticky || undefined} highlighted>
    {columns.map((column, index) => (
      <Table.Cell key={column.id} align={column.align}>
        {index === columns.length - 1 && (
          <TruncatedTextCell
            color={totalBalance < 0 ? Color.Red700 : undefined}
            value={formatAmount(totalBalance)}
            weight={isBold ? 'bold' : undefined}
          />
        )}
      </Table.Cell>
    ))}
  </Table.Row>
)
